<template>
  <div v-if="sessionId">
    <learner-report :session-id="sessionId" />
  </div>
</template>

<script>
  import LearnerReport from '@/components/base/learner-reports/learnerReport.vue'
  export default {
    components: { 
      'learner-report': LearnerReport, 
    },
    data () {
      return {
        sessionId: null,
      }
    },
    mounted () {
      this.sessionId = this.$route.params.sessionId 
    },
  }
</script>
